import { useQuery } from '@tanstack/react-query'
import csClient from '~/modules/core/csClient'
import { get as getItem } from '~/utils/storage/memoryStorage'

const getMeRequest = () => csClient.json.get('users/me')

export const useGetMe = () =>
  useQuery({
    queryKey: ['getMe'],
    queryFn: getMeRequest,
    initialData: null,
    select: (res) => {
      if (res?.data) return res?.data
      return {}
    },
    enabled: !!getItem('WORKSPACE_ID'),
  })
